<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div [ngClass]="{'mt-3': produktart !== produktarten.Haushalt}" id="antrag_gebaeudetyp_dach">
    <h6 *ngIf="produktart !== produktarten.Haushalt">Gebäudetyp und Dachung</h6>
    <app-gebaeudetyp-dach [expertMode]="expertMode" [formGroup]="gebaeudetypDach" [parentFormGroupDirective]="parentFormGroupDirective" [showGroup]="produktart !== produktarten.Haushalt"></app-gebaeudetyp-dach>
  </div>
  <div class="mt-3" id="antrag_hunde_personen" *ngIf="showHaftpflichtWeiterePersonenEigenschaften || showHaftpflichtHundeEigenschaften">
    <h6>Haftpflicht</h6>
    <div class="row" *ngIf="showHaftpflichtWeiterePersonenEigenschaften">
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="haftpflichtWeiterePersonenTemplate"></ng-template>
      </div>
    </div>
    <div class="row" *ngIf="showHaftpflichtHundeEigenschaften">
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="haftpflichtHundeTemplate"></ng-template>
      </div>
    </div>
  </div>
  <div class="mt-3" id="antrag_weiterefragen">
    <h6>Allgemeine Fragen</h6>
    <div class="row" *ngIf="produktart !== produktarten.Haushalt">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio">
          <app-label [control]="rohbaudeckung" for="rohbaudeckung">Rohbaudeckung?</app-label>
          <mat-radio-group id="rohbaudeckung" formControlName="rohbaudeckung">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio">
          <div class="text_info">
            <app-label [control]="vinkulierung" for="vinkulierung">Benötigen Sie eine Vinkulierung?</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('VINKULIERUNGINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
              </div>
            </div>
          </div>
          <mat-radio-group id="vinkulierung" formControlName="vinkulierung">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div *ngIf="showVinkulierungGroup">
          <div class="input">
            <app-label [control]="glaeubigerVinkulierung" class="input__label" for="vinkulierungGlaeubiger">Gläubiger:</app-label>
            <mat-form-field>
              <input matInput id="vinkulierungGlaeubiger" formControlName="glaeubigerVinkulierung">
            </mat-form-field>
          </div>
          <div class="input">
            <app-label [control]="geschaeftszahlVinkulierung" class="input__label" for="vinkulierungGeschaeftszahl">Geschäftszahl:</app-label>
            <mat-form-field>
              <input matInput id="vinkulierungGeschaeftszahl" formControlName="geschaeftszahlVinkulierung">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <app-antrag-weitere-fragen [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="weitereFragen" [expertMode]="expertMode" [versicherungsArt]="versicherungsArt" [showVorversicherungGroup]="true" (kuendigungRisikenEvent)="setKuendigungRisiken($event)"></app-antrag-weitere-fragen>
    <app-daten-beratungsprotokoll [showHeadLine]="false" [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="datenBeratungsprotokoll" [antrag]="true" [expertMode]="expertMode"></app-daten-beratungsprotokoll>
  </div>
  <ng-template #haftpflichtHundeTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
          <div>
            <app-label [control]="haftpflichtHundeEigenschaften">Angaben zu Hunden:</app-label>
          </div>
          <div class="hv-sub-list-container pb-5" formArrayName="haftpflichtHundeEigenschaften">
            <div class="hv-sub-list-item-container"
                 *ngFor="let haftpflichtHundeRow of haftpflichtHundeEigenschaften.controls; index as i">
              <div class="hv-sub-list-item-index standard-text-bold">
                {{ i + 1 }}
              </div>
              <app-haftpflicht-hunde class="hv-sub-list-item-content"
                                     [parentFormGroupDirective]="parentFormGroupDirective"
                                     [formGroup]="haftpflichtHundeRow"></app-haftpflicht-hunde>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #haftpflichtWeiterePersonenTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
          <div>
            <app-label [control]="haftpflichtWeiterePersonenEigenschaften">Angaben zu weiteren Personen:</app-label>
          </div>
          <div class="hv-sub-list-container pb-5" formArrayName="haftpflichtWeiterePersonenEigenschaften">
            <div class="hv-sub-list-item-container"
                 *ngFor="let haftpflichtPersonenRow of haftpflichtWeiterePersonenEigenschaften.controls; index as i">
              <div class="hv-sub-list-item-index standard-text-bold">
                {{ i + 1 }}
              </div>
              <app-haftpflicht-personen class="hv-sub-list-item-content"
                                        [parentFormGroupDirective]="parentFormGroupDirective"
                                        [formGroup]="haftpflichtPersonenRow"></app-haftpflicht-personen>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
 </form>
